import {Type} from 'class-transformer';

import {File} from '../file';
import {NativeFile} from '../nativeFile';
import {User} from '../user';

import {Message} from './message';
import {MessageLink} from './messageLink';

/**
 * Message content
 *
 * @category Message Entity
 * */
export class MessageContent {

  /**
   * Text of the message, for info message it will be also here
   * */
  text: string = null;

  /**
   * Users that was mentioned on this message<br>
   * Not implemented yet<br>
   * */
  @Type(() => User)
  mentions: User[] = [];

  /**
   * Message for whom, this message is reply
   * */
  @Type(() => Message)
  replyToMessage: Message = null;

  /**
   * Message attachments.<br>
   * <br>
   * As a message attachments we can send array of WebApiFile or our {@link File} entity<br>
   * In case if WebApiFile will be added, it will convert to {@link NativeFile} be uploaded to server and returned as our {@link File} entity<br>
   * If some attachment must be removed, it must be removed from array and whole array must de sent to server<br>
   * If we need upload more files to existed attachments, just add WebApiFile to array.<br>
   * it also means, that if in attachments there is item with __entity of `WebApiFile`, we need show loader, since it is uploading<br>
   * <br>
   * WebApiFile is:<br>
   * https://developer.mozilla.org/en-US/docs/Web/API/File
   * */
  @Type(() => File, {
    discriminator: {
      property: '__entity',
      subTypes: [
        {value: NativeFile, name: 'WebApiFile'},
        {value: File, name: 'File'}
      ],
    },
    keepDiscriminatorProperty: true
  })
  attachments: (File | NativeFile | any)[] = [];

  /**
   * Link that was used on this message, filled on server<br>
   * For now it is readonly
   *
   * @readonly
   * */
  @Type(() => MessageLink)
  link: MessageLink[] = [];

  /**
   * Only for internal user, no direct calls
   *
   * @ignore
   * @internal
   * */
  constructor(data: Partial<MessageContent> = null) {
    Object.assign(this, data);
  }

  /**
   * @return message text or title of first file
   * */
  getMessageContentPreview() {
    return this.text ? this.text : (this.attachments.length ? this.attachments[0].title + '.' + this.attachments[0].extension : '');
  }


  /**
   * @return message text with links replaced
   * */
  getReplacedText() {
    const content = (this.text || '').split(' ');
    const httpRegex = /^(http|https):\/\//;

    this.link.forEach(link => {
      const findIdx = content.findIndex(item => item === link.link);
      if (findIdx >= 0) {
        const url = content[findIdx];
        if (!httpRegex.test(url)) {
          content[findIdx] = '<a href="https://' + url + '" target="_blank">' + url + '</a>';
        } else {
          content[findIdx] = '<a href="' + url + '" target="_blank">' + url + '</a>';
        }
      }
    });

    return content.join(' ');
  }
}


